/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Segmentation Complete" |
*
* @param {Segment_Event_Group_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_complete_toast = /** @type {((inputs?: Segment_Event_Group_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Segmentation terminee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segmentierung abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segmentazione completa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сегментация завершена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Segmentación completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分割完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメンテーション完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विभाजन पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Segmentação concluída")
	return /** @type {LocalizedString} */ ("Segmentation Complete")
});